import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import styles from './CasePatientHospitalizationFormatter.less';
import DashboardEncounterLinkFormatter from './DashboardEncounterLinkFormatter';
import baseCasePatientAGFormatterParams from 'src/js/lib/raw_rendering/base_case_patient_ag_formatter_params';

class CasePatientAGFormatter extends React.PureComponent {
  render() {
    const {intl} = this.props;
    const {caseId, formattedValue, hasLink, newData, style, value} =
      baseCasePatientAGFormatterParams(this.props, {intl});

    return value ? (
      <div
        className={styles.dlCasePatientHospitalizationFormatter}
        style={style}
      >
        {caseId && hasLink ? (
          <span className={styles.dlEncounterTypeParentWrapper}>
            <span className={styles.dlEncounterTypeParent}>
              <DashboardEncounterLinkFormatter
                {...this.props}
                data={newData}
                value={formattedValue}
              />
            </span>
          </span>
        ) : (
          <span>{formattedValue}</span>
        )}
      </div>
    ) : (
      ''
    );
  }
}

CasePatientAGFormatter.displayName = 'CasePatientAGFormatter';

CasePatientAGFormatter.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  value: PropTypes.string,
};

CasePatientAGFormatter.defaultProps = {
  data: undefined,
  value: undefined,
};

export default injectIntl(CasePatientAGFormatter);
